import { delay } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { call, put } from 'redux-saga/effects';
import * as Api from '../api/resources';
import * as ActionTypes from '../actions/resources';

function* updateResource({ resource }) {
  yield call(delay, 1000);
  yield call(Api.update, resource);
}

function* removeResource({ resource }) {
  yield call(Api.remove, resource.id);
  yield put(ActionTypes.removeResourceSuccess(resource.id));
}

export default function* root() {
  yield [
    takeLatest('UPDATE_RESOURCE', updateResource),
    takeEvery('REMOVE_RESOURCE', removeResource),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/bucket/sagas/resources.js